import * as React from 'react';
import { PageLayout } from '../../../components/Layout';
import { StickyFooterContainer, HeroContainer } from '../Hero';
import { HowItWorkContainer } from '../../common/HowItWork';
import { FAQContainer } from '../../common/FAQ';
import { ModalsContainer } from '../Modals';
import { useSelector } from 'react-redux';
import { selectIsWebview } from '../../../selectors';
import { AboutSdelka } from '../../common/AboutSdelka';
import { ProfiContainer } from '../../common/Profi';
import { ReferralLinkFallbackModal } from '../ReferralLinkFallbackModal';

export const PageContainer: React.FC = () => {
  const isWebview = useSelector(selectIsWebview);

  React.useEffect(() => {
    /* istanbul ignore next */
    /* Костыль для ручного скрытия хэдэра на мобилке, что бы сохранялась авторизация */
    if (typeof window !== 'undefined' && isWebview) {
      const header = document.querySelector('[data-name=HeaderLayout]') as HTMLBodyElement;

      if (header) {
        header.style.display = 'none';
      }
    }
  }, []);

  return (
    <>
      <HeroContainer />

      <PageLayout>
        <AboutSdelka />
        <HowItWorkContainer />
        <ProfiContainer />
        <FAQContainer />
      </PageLayout>

      <ModalsContainer />
      <ReferralLinkFallbackModal />
      <StickyFooterContainer />
    </>
  );
};
